import React from 'react';
import PropTypes from 'prop-types';
import { DarkScreenMask, PrimaryButton } from '../../..'

import { GREEN_SUCCESS, ORANGE, WHITE } from '../../../styles/shared/colors';
import './DeleteVideoModal.scss';

const DeleteVideoModal = ({ onApprove, onDecline, isVisible })=> {
  return (
    <DarkScreenMask isVisible={isVisible}>
      <div className="delete-video-modal">
        <span>Are you sure you want to delete this game?</span>
        <div>
          <PrimaryButton 
            background={ORANGE} 
            color={WHITE}
            onClick={onDecline}
          >
            NO
          </PrimaryButton>
          <PrimaryButton 
            background={GREEN_SUCCESS} 
            color={WHITE}
            onClick={onApprove}
          >
            YES
          </PrimaryButton>
        </div>
      </div>
    </DarkScreenMask>
  );
};

DeleteVideoModal.propTypes = {
  isVisible: PropTypes.bool,
  onApprove: PropTypes.func,
  onDecline: PropTypes.func 
};

DeleteVideoModal.defaultProps = {
  isVisible: false, 
  onApprove: ()=> {},
  onDecline: ()=> {} 
};

export default DeleteVideoModal;